






















import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Models
import Item from '@/models/Item'

// Mixins
import ErrorsMixin from '@/mixins/Errors'
import FormMixin from '@/mixins/Form'
import ItemMixin from '@/mixins/Item'
import ModalMixin from '@/mixins/Modal'

// Components
import ModalWrapper from '@/components/common/ModalWrapper.vue'


@Component({
  components: {
    ModalWrapper
  }
})
export default class ImportItemModal extends Mixins(ErrorsMixin, FormMixin, ItemMixin, ModalMixin) {
  file = null
  fileName = null
  result = null

  fileLoading: boolean = false

  @Getter('token') token
  @Prop() datas


  emit(file) {
    this.fileLoading = true
    this.fileName = file.name
    const csv = file
    const reader = new FileReader()

    reader.addEventListener('load', () => {
      this.fileLoading = false
      this.result = (reader.result as any).split(',')[1]
    })

    reader.readAsDataURL( csv )
  }

  async submit() {
    if (!this.result) {
      return
    }

    try {
      this.formLoading = true
      const payload = {
        categoryId: this.categoryId.toString(),
        identifier: this.identifier,
        type: this.datas.type,
        body: {
          data: this.result
        }
      }
      const res = await this.$api.items.importCsv(this.token, payload)
      this.close()
      // TODO reload
      this.$router.replace({ name: 'indexItems' })
      this.$toast.open({
        message: this.$t('item.add.import.csv.notification.success') as string,
        type: 'is-success',
        duration: 5000
      })
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.formLoading = false
    }
  }
}
